import React, { Fragment } from 'react'
import styled from 'styled-components/macro'
import { FieldListHeader, FieldListField } from '../../../../components/FormFields/FieldList'
import { media } from '../../../../utils/styles'

const FielListHeaderNoBorder = styled(FieldListHeader)`
  border-bottom: none;
  display: block;
  width: 100%;
  float: left;
  margin-bottom: 30px;
`
const MsgFieldList = styled(FieldListField)`
  margin: 15px 0;
  text-align: left;
  float: right;
  font-size: 10.8px;
  max-width: 50%;

  ${media('phone')`
    max-width: 45%;
    font-size: 11.4px;
  `};
  
  ${media('tablet')`
    font-size: 11px;
    max-width: 45%;
  `}

  ${media('desktop')`
    font-size: 12.6px;
    max-width: 40%;
  `}
  ${media('large')`
    font-size: 13.4px;
    max-width: 35%;
  `};
  ${media('xLarge')`
    font-size: 15px;
    max-width: 30%;
  `};
`

function StatusSteps() {
  return (
    <Fragment>
      <FielListHeaderNoBorder>
        {/* <MsgFieldList flex='7' as='span'></MsgFieldList>
        <MsgFieldList flex='7' as='span'></MsgFieldList> */}
        <MsgFieldList flex='3' as='p'>* Al presionar el botón de continuar sus datos permanecerán guardados durante el plazo de 1 mes.</MsgFieldList>
      </FielListHeaderNoBorder>
    </Fragment>
  )
}

export default StatusSteps
